import moment from 'moment';

export default function loadMomentDate(dateValue?: string) {
  if (!dateValue) {
    return undefined;
  }
  return moment.utc(dateValue);
}
